module.exports = __webpack_public_path__ + "static/media/commercial.41a81546.jpeg";